import { ApiResponse, Fetch, FetchOptions } from '@/types';
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

const instance = axios.create({
  withCredentials: false,
  baseURL: ''
});
instance.interceptors.request.use((config: AxiosRequestConfig) => {
  const { params, timeout } = config;
  if (typeof params === 'number') {
    config.timeout = params;
    config.params = {};
  }
  return config;
});
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error.response);
  }
);

// 目前只用到get，故只实现了get方法
export const get: Fetch = async <T = any>({ url, params, timeout }: FetchOptions): Promise<ApiResponse<T>> => {
  const res = await instance.get(url, { params, timeout });
  return {
    headers: res.headers,
    body: tryParse(res.data)
  }
};

const tryParse = (data: string) => {
  try {
    return JSON.parse(data);
  } catch(e) {
    return data;
  }
};
